// extracted by mini-css-extract-plugin
export var changeIcon = "_5n-4";
export var clickable = "_5n-8";
export var container = "_5n-0";
export var divider = "_5n-7";
export var externalLinkIcon = "_5n-1";
export var green = "_5n-5";
export var helpCircleIcon = "_5n-3";
export var iconButton = "_5n-2";
export var red = "_5n-6";